webpackJsonp([56660325458610],{

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.e4553644.gif";

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.f2db1e8c.png";

/***/ }),

/***/ 1185:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(715);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(716);
	
	var _4 = _interopRequireDefault(_3);
	
	var _reactResponsiveEmbed = __webpack_require__(26);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Low Damage Design"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement("img", { src: _2.default, style: { width: '100%', height: '100%' } }),
	      "Citing the words in the PRESS Design handbook (Pampanin et al., 2010): \u201CMajor advances have been observed in the last decade in seismic engineering with further refinements of performance-based seismic design philosophies and the definition of corresponding compliance criteria. Following the worldwide recognized expectation and ideal aim to provide a modern society with high (seismic) performance structures able to sustain a design level earthquake with limited or negligible damage, emerging solutions have been developed for high-performance, still cost-effective, seismic resisting systems, based on adequate combination of traditional materials and available technology.\u201D ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "The PRESSS system"
	      ),
	      "\u201COne of those is the PREcast Seismic Structural System (PRESSS), developed at the University of California, San Diego (Priestley, 1991, 1996; Priestley et al. 1999). In this system, precast elements are jointed together through unbonded post-tensioning tendons/strands or bars. The inelastic demand is accommodated within the connection itself (beam-column, column to foundation or wall-to-foundation critical interface), through the opening and closing of an existing gap (rocking motion) while reduced level of damage, when compared to equivalent cast-in-place solutions.\u201D ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "My experience"
	      ),
	      "I had the incredible opportunity to learn how to design such kind of structures in a course at the ROSE school in Pavia, called \u201CSeismic Design of Low-Damage Concrete and Timber Buildings\u201D by professor Stefano Pampanin. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: "https://www.youtube.com/embed/X9vDWHWCoik", allowFullScreen: true }),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: "https://www.youtube.com/embed/xazfxid0DAE", allowFullScreen: true })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lowdamage-en-jsx-20af4d4768edf420d965.js